<template>
  <div>
    <Divider orientation="left">单位基本信息</Divider>
    <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
      <Row :gutter="16">
        <Col span="12">
        <FormItem label="单位名称" prop="enterpriseName">
          <Input v-model.trim="form.enterpriseName" disabled placeholder="自动回显"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="社会统一信用代码" prop="enterpriseCode">
          <Input v-model.trim="form.enterpriseCode" disabled placeholder="自动回显"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="人事姓名" prop="personnelId">
          <Select v-model.trim="form.personnelId" style="width:100%" @on-change="personnalChange" :disabled="$store.state.isDisableEnterpriseAgentInput">
            <Option :value="value" v-for="{name,value} in enterpriseAgentList" :key="value">{{name}}</Option>
          </Select>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="人事身份证号">
          <Input v-model.trim="form.personnelIDCardNo" disabled placeholder="根据选择的人事显示"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="人事联系方式">
          <Input v-model.trim="form.personnelPhone" disabled placeholder="根据选择的人事显示"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem  class="noticeTop" label="上传人事介绍信" prop="personnelLetterGuid">
          <Upload ref="personnelLetterGuid" :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :on-preview="handlePreview" :before-upload='(file)=>handleBefore("personnelLetterGuid")'
            :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'personnelLetterGuid')"
            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid',false)" :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('personnelLetterGuid',false)">手机拍照上传</Button>
          </Upload>
        </FormItem>
        <FormItem class="notice">
          <div >
            <a class="_link" :href="$baseURL +'/templates/人事介绍信模版.docx'">下载人事介绍信模版</a>
          </div>
            <div class="_linkdel" v-for="file in form.personnelLetterGuidPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'personnelLetterGuid')" />
            </div>
          </div>
        </FormItem>
        </Col>
        <Col span="12" v-if="$store.state.enterpriseIsShanghaiBranch">
        <!-- prop="enterpriseTaxReceiptGuid" -->
        <FormItem class="noticeTop"  label="单位近一年税单" prop="enterpriseTaxReceiptGuid" :rules="{ required: $store.state.enterpriseIsShanghaiBranch, message: '请上传', trigger: 'blur' }">
          <Upload ref="enterpriseTaxReceiptGuid" :accept="$store.state.globalAccept" :format="$store.state.globalFormat"  :show-upload-list="false" style="flex:1;" :on-preview="handlePreview"  :before-upload='(file)=>handleBefore("enterpriseTaxReceiptGuid")'
            :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'enterpriseTaxReceiptGuid',)"
            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'enterpriseTaxReceiptGuid')" :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('enterpriseTaxReceiptGuid',false)">手机拍照上传</Button>
          </Upload>
        </FormItem>
        <FormItem class="notice">
          <div>
            注：税单上未显示单位名称需要单位盖章
          </div>
           <div class="_linkdel" v-for="file in form.enterpriseTaxReceiptGuidPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'enterpriseTaxReceiptGuid')" />
            </div>
          </div>
        </FormItem>
        
        </Col>
      </Row>
      <div class="bom_btn">
        <div>
          <Button  @click="next(null,-1)" >上一步</Button>
          <Button type="primary" @click="next('form'+current,1)" >下一步</Button>
        </div>
      </div>
    </Form>
  </div>
</template>
<script>
export default {
  props: {
    form: { type: Object },
    current: { type: Number },
    nextBtnClose: { type: Boolean },
    enterpriseAgentList: { type: Array },
    isEnterprise: { type: Boolean },
  },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      appInfoDataType: this.$store.state.appInfoDataType,
      uploadData: {},
      rules: {
        personnelId: [{ required: true, type: 'number', message: '请选择', trigger: 'blur' }],
        enterpriseName: [{ required: true, message: '请输入', trigger: 'blur' }],
        enterpriseCode: [{ required: true, message: '请输入', trigger: 'blur' }],
        isLaborDispatchPermit: [
          { required: true, message: '请选择', type: 'boolean', trigger: 'blur' },
        ],
        personnelIDCardNo: [{ required: true, message: '请输入', trigger: 'blur' }],
        personnelPhone: [{ required: true, message: '请输入', trigger: 'change' }],
        enterpriseBusinessLicenseGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
        personnelIDCardFrontGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
        personnelIDCardBackGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
        personnelLetterGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
        // enterpriseTaxReceiptGuid: [{ required: this.$store.state.enterpriseIsShanghaiBranch, message: '请上传', trigger: 'blur' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //   this.$Message.success('Success!')
      if (name === null) {
        this.$emit('next', val,`/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`)
        return
      }
      let _this = this
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        this.$emit('next', val, `/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`)
      })
    },
    //暂存
    async submitStore() {
      this.$emit('submit', `/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`, 0, '保存成功')
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
      this.$refs['form' + this.current].validateField(property)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      this.$refs[property].clearFiles()
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //人事更改
    personnalChange(e) {
      this.$emit('personnalChange', e)
    },
  },
}
</script>
